// extracted by mini-css-extract-plugin
export default {"videoWrapper":"VideoWrapper_videoWrapper__VNd1J"};